import { useTranslation } from 'react-i18next';
import PublicContentPage, { PublicCtaLink } from '../components/layout/PublicContentPage';

const PARTNER_CONTACT_HREF = 'mailto:sales@ablecomply.com?subject=AbleComply%20Partner%20Program';

interface PartnerContentItem {
  title: string;
  body: string;
}

export default function PartnersPage() {
  const { t } = useTranslation('marketing');
  const fitItems = t('pages.partners.fit.items', { returnObjects: true }) as PartnerContentItem[];
  const benefitItems = t('pages.partners.benefits.items', { returnObjects: true }) as PartnerContentItem[];
  const stepItems = t('pages.partners.howItWorks.items', { returnObjects: true }) as PartnerContentItem[];
  const sidebarPoints = t('pages.partners.sidebar.points', { returnObjects: true }) as string[];

  return (
    <PublicContentPage
      metaTitle={t('pages.partners.meta.title')}
      metaDescription={t('pages.partners.meta.description')}
      canonicalPath="/partners"
      eyebrow={t('pages.partners.hero.eyebrow')}
      title={t('pages.partners.hero.title')}
      intro={t('pages.partners.hero.intro')}
      aside={(
        <>
          <section className="acc-public-page-card acc-public-page-card--sticky">
            <h2>{t('pages.partners.sidebar.title')}</h2>
            <p>{t('pages.partners.sidebar.body')}</p>
            <ul className="acc-public-page-list">
              {sidebarPoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <div className="acc-public-page-actions">
              <PublicCtaLink href="/partners/apply">
                {t('pages.partners.sidebar.applyAction')}
              </PublicCtaLink>
              <PublicCtaLink href={PARTNER_CONTACT_HREF} variant="ghost">
                {t('pages.partners.sidebar.contactAction')}
              </PublicCtaLink>
            </div>
          </section>

          <section className="acc-public-page-card">
            <h2>{t('pages.partners.sidebar.processTitle')}</h2>
            <p>{t('pages.partners.sidebar.processBody')}</p>
          </section>
        </>
      )}
    >
      <section className="acc-public-page-card">
        <h2>{t('pages.partners.fit.heading')}</h2>
        <p>{t('pages.partners.fit.intro')}</p>
        <div className="acc-public-page-grid">
          {fitItems.map((item) => (
            <article key={item.title} className="acc-public-page-subcard">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="acc-public-page-card">
        <h2>{t('pages.partners.benefits.heading')}</h2>
        <p>{t('pages.partners.benefits.intro')}</p>
        <div className="acc-public-page-grid">
          {benefitItems.map((item) => (
            <article key={item.title} className="acc-public-page-subcard">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="acc-public-page-card">
        <h2>{t('pages.partners.howItWorks.heading')}</h2>
        <p>{t('pages.partners.howItWorks.intro')}</p>
        <div className="acc-public-page-grid">
          {stepItems.map((item) => (
            <article key={item.title} className="acc-public-page-subcard">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="acc-public-cta-band">
        <div>
          <h2>{t('pages.partners.cta.title')}</h2>
          <p>{t('pages.partners.cta.body')}</p>
        </div>
        <div className="acc-public-cta-actions">
          <PublicCtaLink href="/partners/apply" variant="primary">
            {t('pages.partners.cta.applyAction')}
          </PublicCtaLink>
          <PublicCtaLink href={PARTNER_CONTACT_HREF} variant="secondary">
            {t('pages.partners.cta.contactAction')}
          </PublicCtaLink>
        </div>
      </section>
    </PublicContentPage>
  );
}
